import UseContext from 'hooks/useContext';
import { invoiceRemindersText } from './invoiceRemindersText';

/**
 * The name of the "Rappels / Relances" tab with the count of "À faire"
 * (JBWEB-1283), once known and above zero.
 */
const RemindersTabName = ({ label, toDo }) => {
  const { language } = UseContext();
  const text = invoiceRemindersText(language);
  // The name alone, as the other tabs have it, until there is something to count.
  if (!Number.isInteger(toDo) || toDo <= 0) return label;

  return (
    <span className="flex items-center gap-2">
      <span>{label}</span>
      <span
        title={text('tabCount', { count: toDo })}
        aria-label={text('tabCount', { count: toDo })}
        className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded bg-yellow-100 text-xs font-medium text-yellow-800"
      >
        {toDo}
      </span>
    </span>
  );
};

export default RemindersTabName;
